document.addEventListener('alpine:init', function () {
    Alpine.data('quickLinks', function () {
        var headerBannerElement;
        return {
            expanded: true,
            height: 0,
            links: [],
            init: function () {
                // The previous module should be the Header Banner module. Let's grab it.
                headerBannerElement = document.querySelector('[data-module="header-banner"]');
                this.detectQuickLinks();
                this.watchForBreakpointChanges();
            },
            watchForBreakpointChanges: function () {
                var _this = this;
                // Make sure the expandable section is expanded when we go on a large screen,
                // since we'll be hiding the button to collapse the links.
                this.$watch('$store.app.lg', function () {
                    if (_this.$store.app.lg) {
                        _this.expanded = true;
                    }
                    _this.detectHeight();
                });
            },
            detectQuickLinks: function () {
                var links = Array.from(document.body.querySelectorAll('[data-quick-link]'));
                if (!links.length)
                    return;
                this.links = links.map(function (link) { return ({
                    el: link,
                    title: link.textContent,
                }); });
            },
            goTo: function (el, title) {
                this.$store.app.scrollTo(el, 200);
                this.$store.app.track({
                    event: "click_jumplink",
                    type: 'click',
                    module: 'quick-links',
                    data: {
                        title: title.trim(),
                    },
                });
            },
        };
    });
});
